/* @ngInject */
const newDispatch = (
  utils,
  dispatchLabels
) => {
  const self = {}

  self.classic = () => {
    return {
      id: null,
      date: utils.date.getTodayString(),
      hour: null,
      prg: null,
      sgm: null,
      comment: dispatchLabels.statements.defaultComment,
      departure: null,
      delivery: null,
      tractionnaire: null,
    }
  }

  self.search = () => {
    return {
      id: null,
      date: null,
      hour: null,
      prg: null,
      prgNull: 'any',
      prgOperator: '=',
      sgm: null,
      sgmNull: 'any',
      sgmOperator: '=',
      comment: null,
      departure: null,
      departureNull: 'any',
      departureOperator: '=',
      delivery: null,
      deliveryNull: 'any',
      deliveryOperator: '=',
      tractionnaire: null,
      tractionnaireNull: 'any',
      tractionnaireOperator: '=',
    }
  }

  return self
}

export default newDispatch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/new.service.js